// Catálogo tipado de feature flags: fuente única de nombres + valor por defecto.
// El `default` es el valor usado cuando el proveedor no responde (degradación).
// Recomendación: `false` para features nuevas (fail-closed) salvo justificación.

export const FEATURE_FLAGS = {
  IA_MODE: { key: 'ai_mode', default: true },
} as const

export type FeatureFlagKey =
  (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS]['key']

/** Devuelve el valor por defecto declarado en el catálogo para una key. */
export function defaultForFlag(key: string): boolean {
  const found = Object.values(FEATURE_FLAGS).find((flag) => flag.key === key)
  return found?.default ?? false
}
